import { ReactComponent as StarCheckedIcon } from './star_checked.svg';

export default StarCheckedIcon;
